import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';
import { menuAim } from './menu-aim';
import { TimelineLite } from 'gsap';
import focusWithin from 'ally.js/esm/style/focus-within.js';

Snappy.Component.CFANav = class CFANav extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-nav';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

        if (App.isDesktop) {
            this.initSticky();
            this.initMenuAim();
            this.initSearch();
            this.initKeyboardNavigation();
            this.switchTabOrder();
        } else {
            this.initMobile();
        }

        let handle = focusWithin();
    }

    setVars() {
        this.stickyElement = this.$element.find('.js-sticky-nav');
        this.stickyContainer = this.$element.find('.js-sticky-nav-container');

        this.navContainer = this.$element.find('.js-cfa-nav-container');
        this.mobileNavOpener = this.$element.find('.js-mobile-nav-opener');

        this.mainNav = this.$element.find('.js-cfa-main-nav');
        this.subNav = this.$element.find('.js-cfa-sub-nav');

        this.secondLevelMenu = this.$element.find('.js-cfa-second-level-menu');
        this.menuContent = this.$element.find('.js-cfa-menu-content');

        this.thirdLevelMenu = this.$element.find('.js-cfa-nav-third-level-menu');
        this.menuItem = this.$element.find('.js-menu-item');

        this.menuItemForward = this.$element.find('.js-menu-item-forward');
        this.menuItemBackward = this.$element.find('.js-menu-item-backward');

        this.firstLevelButtons = this.$element.find('.js-cfa-nav-first-level-button');
        this.secondLevelButtons = this.$element.find('.js-cfa-nav-second-level-button');
        this.activeFirstLevelItem = null;
        this.activeSecondLevelItem = null;

        this.isSearchOpened = false;
        this.search = this.$element.find('.js-cfa-search');
        this.openSearch = this.$element.find('.js-cfa-search-open');
        this.closeSearch = this.$element.find('.js-cfa-search-close');
        this.searchForm = this.$element.find('.js-cfa-search-form');
        this.searchInput = this.$element.find('.js-cfa-search-input');
        this.searchUrl = this.search.data('url');
        this.isGoogleSearch = this.search.is('[data-google-search]');

        this.isMobile = !App.isDesktop;
        this.isRunning = false;
        this.isDesktopMenuOpened = false;
        this.isMobileMenuOpened = false;
        this.isMenuFocused = false;
        this.isSticky = false;
        this.translateValue = 0;
    }

    setEventListeners() {
        this.$window.on('resize:finished', (this.bindedResize = this.onResize.bind(this)));
        this.$body.on('body:block', this.onBodyBlock.bind(this));
        this.$body.on('body:unblock', this.onBodyUnblock.bind(this));

        this.navContainer.on('transitionend', this.onNavTransitionEnd.bind(this));
        this.openSearch.on('click', this.onSearchOpen.bind(this));
        this.searchInput.on('keyup', this.onSearchKeyup.bind(this));

        $(document).on('show.bs.modal', '#IrSignInModal', this.onModalShow.bind(this));
        $(document).on('hidden.bs.modal', '#IrSignInModal', this.onModalHide.bind(this));
    }

    initKeyboardNavigation() {
        this.firstLevelButtons.on('click', this.onClickFirstLevelButton.bind(this));
        this.secondLevelButtons.on('click', this.onClickSecondLevelButton.bind(this));
    }

    onModalShow() {
        if (this.clientHeight <= window.innerHeight) {
            return;
        }
        const scrollbarWidth = this.getScrollBarWidth();
        if (scrollbarWidth) {
            this.stickyElement
                .filter((index, el) => {
                    return $(el)
                        .parents('.js-sticky-nav-container')
                        .hasClass('is-fixed');
                })
                .css('padding-right', scrollbarWidth);
        }
    }

    onModalHide() {
        this.stickyElement
            .filter((index, el) => {
                return $(el)
                    .parents('.js-sticky-nav-container')
                    .hasClass('is-fixed');
            })
            .css('padding-right', 0);
    }

    getScrollBarWidth() {
        var inner = document.createElement('p');
        inner.style.width = '100%';
        inner.style.height = '200px';

        var outer = document.createElement('div');
        outer.style.position = 'absolute';
        outer.style.top = '0px';
        outer.style.left = '0px';
        outer.style.visibility = 'hidden';
        outer.style.width = '200px';
        outer.style.height = '150px';
        outer.style.overflow = 'hidden';
        outer.appendChild(inner);

        document.body.appendChild(outer);
        var w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        var w2 = inner.offsetWidth;
        if (w1 == w2) w2 = outer.clientWidth;

        document.body.removeChild(outer);

        return w1 - w2;
    }

    onClickFirstLevelButton(event) {
        const activeFirstLevelItem = $(event.target).parents('.js-cfa-nav-first-level-item');

        event.preventDefault();
        event.stopPropagation();

        if (this.activeFirstLevelItem) {
            if (this.activeSecondLevelItem) {
                this.deactivateThirdLevelMenu(this.activeSecondLevelItem);
                this.closeThirdLevelMenu(this.activeSecondLevelItem);
                this.activeSecondLevelItem = null;
            }

            this.deactivateSecondLevelMenu();
            this.closeSecondLevelMenu();

            if (activeFirstLevelItem[0] === this.activeFirstLevelItem[0]) {
                this.activeFirstLevelItem = null;
                return;
            }
        }

        this.activeFirstLevelItem = activeFirstLevelItem;
        this.activateSecondLevelMenu(event.target);
    }

    onClickSecondLevelButton(event) {
        const activeSecondLevelItem = $(event.target).parents('.js-cfa-nav-second-level-item');

        event.preventDefault();
        event.stopPropagation();

        if (this.activeSecondLevelItem) {
            this.deactivateThirdLevelMenu();
            this.closeThirdLevelMenu();

            if (activeSecondLevelItem[0] === this.activeSecondLevelItem[0]) {
                this.activeSecondLevelItem = null;
                return;
            }
        }

        this.activeSecondLevelItem = activeSecondLevelItem;
        this.activateThirdLevelMenu(event.target);
    }

    initSearch() {
        this.search.on('transitionend', this.onSearchTransitionEnd.bind(this));
        this.closeSearch.on('click', this.onSearchClose.bind(this));
    }

    onSearchKeyup(e) {
        if (e && e.keyCode === 13) {
            this.onSearchSubmit();
        }
    }

    onSearchSubmit() {
        const keyword = this.searchInput.val();

        if (keyword === '') {
            return;
        }

        if (this.isGoogleSearch) {
            const query = this.searchForm.serialize();
            window.location.href = this.searchForm.attr('action') + '?' + query;
        } else {
            window.location.href = this.searchUrl + '?keyword=' + keyword + '&page=1';
        }

        const currentSection = this.searchForm.data('currentSection');
        if (currentSection && !this.isSubmitTracked) {
            $(window).trigger('gtm:send', [currentSection, 'Search', keyword]);
            this.isSubmitTracked = true;
        }
    }

    onSearchOpen(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        const inputValue = this.searchInput.val();

        if (this.isMobile) {
            if (inputValue !== '') {
                this.onSearchSubmit();
            }

            return;
        }

        if (this.isSearchOpened && inputValue !== '') {
            this.onSearchSubmit();
        } else {
            this.isSearchOpened = true;
            this.search.addClass('cfa-search--opened');
            this.search.addClass('cfa-search--visible');
        }
    }

    onSearchClose(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        this.isSearchOpened = false;
        this.search.removeClass('cfa-search--opened');
        this.openSearch.focus();
    }

    onSearchTransitionEnd(e) {
        if (e.target !== this.search[0]) {
            return;
        }

        if (this.isSearchOpened) {
            this.searchInput.focus();
        } else {
            this.search.removeClass('cfa-search--visible');
        }
    }

    initMenuAim() {
        this.mainNav.menuAim({
            rowSelector: '> ul > li',
            submenuDirection: 'below',
            tolerance: 0,
            activate: function(el) {
                this.activateSecondLevelMenu(el);
            }.bind(this),
            deactivate: function(el) {
                this.deactivateSecondLevelMenu(el);
            }.bind(this),
            exitMenu: this.closeSecondLevelMenu.bind(this)
        });

        this.subNav.menuAim({
            activate: function(el) {
                this.activateThirdLevelMenu(el);
            }.bind(this),
            deactivate: function(el) {
                this.deactivateThirdLevelMenu(el);
            }.bind(this),
            exitMenu: this.closeThirdLevelMenu.bind(this)
        });
    }

    activateSecondLevelMenu(triggerElem) {
        if (this.isSearchOpened) {
            return;
        }

        this.activeFirstLevelItem = $(triggerElem).hasClass('js-cfa-nav-first-level-item')
            ? $(triggerElem)
            : $(triggerElem).parents('.js-cfa-nav-first-level-item');
        this.activeFirstLevelItem.addClass('cfa-nav__item--active');

        const newMenu = this.activeFirstLevelItem.find('.js-cfa-nav-second-level-menu').get(0);

        if (newMenu && !this.isDesktopMenuOpened) {
            let newContent = newMenu.querySelector('.js-cfa-menu-content');

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween.set(newMenu, { display: 'block' });
            this.tween.set(newContent, { autoAlpha: 1 });
            this.tween.to(newMenu, 0.2, {
                autoAlpha: 1,
                ease: Power0.easeNone
            });
            this.tween.play();

            newMenu.style.pointerEvents = 'auto';

            this.isDesktopMenuOpened = true;
            this.currentDesktopMenu = newMenu;
        } else if (newMenu && this.isDesktopMenuOpened) {
            let oldMenu = this.currentDesktopMenu,
                oldContent = oldMenu.querySelector('.js-cfa-menu-content'),
                newContent = newMenu.querySelector('.js-cfa-menu-content');

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(oldContent, 0.2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(newMenu, { display: 'block', autoAlpha: 1 })
                .set(oldMenu, { display: 'none', autoAlpha: 0 })
                .to(newContent, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            oldMenu.style.pointerEvents = 'none';
            newMenu.style.pointerEvents = 'auto';

            this.currentDesktopMenu = newMenu;
        } else {
            this.closeSecondLevelMenu();
        }
    }

    closeSecondLevelMenu() {
        if (this.isDesktopMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(this.currentDesktopMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                })
                .set(this.currentDesktopMenu, { display: 'none' })
                .set(this.currentDesktopMenu.querySelector('.js-cfa-menu-content'), {
                    autoAlpha: 1
                });
            this.tween.play();

            this.currentDesktopMenu.style.pointerEvents = 'none';

            this.currentDesktopMenu = null;
            this.isDesktopMenuOpened = false;
        }

        return true;
    }

    deactivateSecondLevelMenu() {
        if (this.isSearchOpened) {
            return;
        }

        this.activeFirstLevelItem.removeClass('cfa-nav__item--active');
    }

    activateThirdLevelMenu(triggerElem) {
        this.activeSecondLevelItem = $(triggerElem).hasClass('js-cfa-nav-second-level-item')
            ? $(triggerElem)
            : $(triggerElem).parents('.js-cfa-nav-second-level-item');
        this.activeSecondLevelItem.addClass('cfa-menu__item--active');

        const newSubMenu = this.activeSecondLevelItem.find('.js-cfa-nav-third-level-menu')[0];

        if (newSubMenu && !this.isDesktopSubMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .set(newSubMenu, { display: 'block' })
                .set(this.currentDesktopMenu, {
                    height:
                        newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight
                            ? newSubMenu.scrollHeight + 40
                            : 'auto'
                })
                .to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            newSubMenu.style.pointerEvents = 'auto';

            this.isDesktopSubMenuOpened = true;
            this.currentDesktopSubMenu = newSubMenu;
        } else if (newSubMenu && this.isDesktopSubMenuOpened) {
            let oldSubMenu = this.currentDesktopSubMenu;

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .set(newSubMenu, { display: 'block' })
                .set(this.currentDesktopMenu, {
                    height:
                        newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight
                            ? newSubMenu.scrollHeight + 40
                            : 'auto'
                })
                .to(oldSubMenu, 0.2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(oldSubMenu, { display: 'none' })
                .to(newSubMenu, 0.2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();
            oldSubMenu.style.pointerEvents = 'none';
            newSubMenu.style.pointerEvents = 'auto';

            this.currentDesktopSubMenu = newSubMenu;
        } else {
            this.closeThirdLevelMenu();
        }
    }

    deactivateThirdLevelMenu(el) {
        if (!this.activeSecondLevelItem) return;

        this.activeSecondLevelItem.removeClass('cfa-menu__item--active');
    }

    closeThirdLevelMenu() {
        if (this.isDesktopSubMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(this.currentDesktopSubMenu, 0.2, {
                    autoAlpha: 0,
                    ease: Power0.easeNone
                })
                .set(this.currentDesktopSubMenu, { display: 'none' })
                .set(this.currentDesktopMenu, { height: 'auto' });
            this.tween.play();

            this.currentDesktopSubMenu.style.pointerEvents = 'none';

            this.currentDesktopSubMenu = null;
            this.isDesktopSubMenuOpened = false;
        }

        return true;
    }

    tweenPromote(tween) {
        if (typeof tween === 'undefined' || tween == null) return;

        if (typeof tween.progress === 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);
        }

        if (typeof tween.destroy === 'function') {
            tween.destroy();
        }
    }

    destroyMenuAim() {
        this.mainNav.menuAim('destroy');
        this.subNav.menuAim('destroy');
        this.secondLevelMenu.removeAttr('style');
        this.menuContent.removeAttr('style');
        this.thirdLevelMenu.removeAttr('style');
    }

    initSticky() {
        if (this.$body.hasClass('is-experience-editor') || !this.stickyContainer.length) {
            return;
        }

        this.getStickyData();
        this.onScroll();
        $(window).on('scroll', (this.bindedScroll = this.onScroll.bind(this)));
    }

    destroySticky() {
        this.deactivateSticky();
        $(window).off('scroll', this.bindedScroll);
    }

    getStickyData() {
        this.stickyOffset = this.stickyContainer.height();
        this.offset = this.stickyElement.offset().top;
    }

    activateSticky() {
        this.stickyContainer.addClass('is-fixed');
        this.stickyContainer.css('height', this.stickyOffset);
    }

    deactivateSticky() {
        this.stickyContainer.removeClass('is-fixed');
        this.stickyContainer.css('height', 'auto');
        this.isSticky = false;
    }

    initMobile() {
        this.mobileNavOpener.on(
            'click',
            (this.bindedHamburgerClick = this.onHamburgerClick.bind(this))
        );
        this.menuItemForward.on(
            'click',
            (this.bindedForwardClick = this.onForwardClick.bind(this))
        );
        this.menuItemBackward.on(
            'click',
            (this.bindedBackwardClick = this.onBackwardClick.bind(this))
        );
    }

    onBodyBlock() {
        this.pageOffset = this.$body.scrollTop();
        this.$body.addClass('is-blocked');
        this.$body.css('top', -this.pageOffset);
    }

    onBodyUnblock() {
        this.$body.css('top', 'initial');
        this.$body.removeClass('is-blocked');
        window.scrollTo(0, this.pageOffset);
    }

    destroyMobile() {
        this.resetMenu();
        this.mobileNavOpener.off('click', this.bindedHamburgerClick);
        this.menuItemForward.off('click', this.bindedForwardClick);
        this.menuItemBackward.off('click', this.bindedBackwardClick);
    }

    resetMenu() {
        this.translateValue = 0;
        this.navContainer.css('transform', '');
        this.menuItem.removeClass('is-active');
    }

    onHamburgerClick() {
        this.isMobileMenuOpened = !this.isMobileMenuOpened;
        this.resetMenu();
        this.toggleHamburger();
        this.toggleMenu();
        this.toggleBodyBlock();
    }

    onNavTransitionEnd(e) {
        if (e.target !== this.navContainer[0]) {
            return;
        }

        this.isRunning = false;
        if (this.translateValue === -100) {
            this.subNav.find('li.is-active').removeClass('is-active');
        } else if (this.translateValue === 0) {
            this.mainNav.find('li.is-active').removeClass('is-active');
        }
    }

    onForwardClick(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        if (this.isRunning) {
            return;
        } else {
            this.isRunning = true;
        }

        const forwardLink = $(e.currentTarget);
        forwardLink.closest('.js-menu-item').addClass('is-active');

        this.translateValue -= 100;
        this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
    }

    onBackwardClick(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        if (this.isRunning) {
            return;
        } else {
            this.isRunning = true;
        }

        //const backwardLink = $(e.currentTarget);

        this.translateValue += 100;
        this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
    }

    toggleHamburger() {
        this.mobileNavOpener.toggleClass('is-active', this.isMobileMenuOpened);
    }

    toggleMenu() {
        this.$element.toggleClass('is-mobile-active', this.isMobileMenuOpened);
    }

    toggleBodyBlock() {
        if (this.isMobileMenuOpened) {
            this.$body.trigger('body:block');
        } else {
            this.$body.trigger('body:unblock');
        }
    }

    onScroll() {
        if (this.isSticky !== this.offset < window.pageYOffset) {
            this.isSticky = !this.isSticky;

            if (this.isSticky) {
                this.activateSticky();
            } else {
                this.deactivateSticky();
            }
        }
    }

    onResize() {
        let screenSize;

        if (App.isDesktop) {
            screenSize = 'desktop';
        } else {
            screenSize = 'mobile';
        }

        this.onBreakpointChange(screenSize);
    }

    onBreakpointChange(screenSize) {
        const wasMobile = this.isMobile;
        const isMobile = screenSize === 'mobile';

        if (isMobile && !wasMobile) {
            if (this.isSearchOpened) {
                this.onSearchClose();
            }

            this.destroySticky();
            //this.destroyKeyboardNavigation();
            this.destroyMenuAim();
            this.initMobile();
        } else if (!isMobile && wasMobile) {
            if (this.isMobileMenuOpened) {
                this.isMobileMenuOpened = false;
                this.toggleMenu();
                this.toggleHamburger();
                this.toggleBodyBlock();
            }

            this.destroyMobile();
            this.initSticky();
            this.initMenuAim();
            this.initSearch();
            //this.initKeyboardNavigation();
        }

        this.isMobile = isMobile;
        this.switchTabOrder();
    }

    switchTabOrder() {
        if (this.isMobile) {
            this.mainNav.insertAfter(this.search);
        } else {
            this.search.insertAfter(this.mainNav);
        }
    }
};



// WEBPACK FOOTER //
// ./components/cfa-nav/scripts/cfa-nav.js